"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const elementScroll_1 = __importDefault(require("./elementScroll"));
function relativePosition(related, alignH, alignV, isParent) {
    let relatedRect = related.getBoundingClientRect();
    const scroll = (0, elementScroll_1.default)(related);
    const rect = {
        x: relatedRect.x,
        y: relatedRect.y,
        width: relatedRect.width,
        height: relatedRect.height,
        left: relatedRect.left + scroll.left,
        right: relatedRect.right + scroll.left,
        top: relatedRect.top + scroll.top,
        bottom: relatedRect.bottom + scroll.top,
    };
    let left, top;
    const { width, height } = rect;
    switch (alignH) {
        case "left":
            left = isParent ? 0 : rect.left;
            break;
        case "right":
            left = isParent ? width : rect.right;
            break;
        case "center":
            left = isParent ? width / 2 : rect.left + width / 2;
            break;
    }
    switch (alignV) {
        case "top":
            top = isParent ? 0 : rect.top;
            break;
        case "bottom":
            top = isParent ? height : rect.bottom;
            break;
        case "middle":
            top = isParent ? height / 2 : rect.top + height / 2;
            break;
    }
    return { top, left, width, height };
}
exports.default = relativePosition;
//# sourceMappingURL=relativePosition.js.map